import { ProgressBar } from 'baseui/progress-bar'
import { StyledCode, StyledCodeBox, StyledCodeExpiry } from './styled-components'
import useRegistrationCode from './useRegistrationCode'

export interface RegistrationCodeProps {
  hidden: boolean
  code: string
  expiryLabel: string
  progress: { value: number; maxValue: number }
}

const RegistrationCode = ({ hidden, code, expiryLabel, progress }: RegistrationCodeProps) => {
  const { isPulse, progressOverrides } = useRegistrationCode()

  if (hidden) {
    return null
  }

  return (
    <StyledCodeBox $pulse={isPulse}>
      <StyledCode $pulse={isPulse}>{code}</StyledCode>
      <StyledCodeExpiry $pulse={isPulse}>{expiryLabel}</StyledCodeExpiry>
      <ProgressBar value={progress.value} maxValue={progress.maxValue} overrides={progressOverrides} />
    </StyledCodeBox>
  )
}

export default RegistrationCode
